export default __webpack_public_path__ + "static/media/soja_r2.a492a3a3.png";